module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-detail-box"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "font",
    on: {
      "click": _vm.bak
    }
  }, [_c('span', {
    staticClass: "el-icon-arrow-left icon"
  }), _vm._v("返回")]), _vm._v(" "), _c('span', {
    staticClass: "shu"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticClass: "font-text"
  }, [_vm._v(_vm._s(_vm.$route.query.companyName))]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('a', {
    attrs: {
      "href": _vm.href
    }
  }, [_c('span', {
    staticClass: "el-icon-download"
  }), _vm._v("导出统计数据")])]), _vm._v(" "), _c('span', {
    staticClass: "export"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.pointByHour
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("用户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "6"
    }
  }, [_vm._v("部门管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "2"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("设备管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7"
    }
  }, [_vm._v("跟踪记录")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "4"
    }
  }, [_vm._v("分析统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "8"
    }
  }, [_vm._v("企业设置")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [(_vm.showCom) ? _c('div', [_c('company')], 1) : _vm._e(), _vm._v(" "), (_vm.showWeP) ? _c('div', [_c('weProduct')], 1) : _vm._e(), _vm._v(" "), (_vm.showDev) ? _c('div', [_c('device')], 1) : _vm._e(), _vm._v(" "), (_vm.showFx) ? _c('Static', {
    attrs: {
      "comId": _vm.$route.query.companyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 6) ? _c('DepartManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 7) ? _c('TrackManage') : _vm._e(), _vm._v(" "), (_vm.activeIndex == 8) ? _c('CompamySetting', {
    attrs: {
      "editLevel": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b9b2cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/account/officalView.vue
// module id = 1721
// module chunks = 9